import { Component } from "@angular/core";

@Component({
  selector: 'bm-ext-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  constructor() {}

}
